import { fmtDate, fmtTime, money } from "@/lib/format";
import { jobTypeColor, textOn } from "@/lib/jobTypes";
import { useSettings } from "@/context/SettingsContext";

const Item = ({ label, value, mono, testId, className = "" }) => (
  <div className={className}>
    <div className="text-[10px] font-semibold uppercase tracking-wider text-sky-200/70">{label}</div>
    <div className={`mt-0.5 truncate text-sm font-medium text-white ${mono ? "font-mono" : ""}`} data-testid={testId} title={typeof value === "string" ? value : undefined}>{value || "—"}</div>
  </div>
);

export const BookingSummary = ({ b }) => {
  const { settings } = useSettings();
  const color = jobTypeColor(settings.job_types, b.job_type);
  return (
    <div className="grid grid-cols-2 gap-x-4 gap-y-3 border-t border-white/10 pt-5 sm:grid-cols-3 lg:grid-cols-6" data-testid="booking-summary">
      <Item label="Moving date" value={fmtDate(b.moving_date, "EEE d MMM yyyy")} testId="summary-date" />
      <Item label="Start time" value={fmtTime(b.start_time)} mono testId="summary-time" />
      <Item label="Job type / route" testId="summary-job-type" value={b.job_type && <span className="rounded px-1.5 py-0.5 text-xs font-semibold" style={{ background: color, color: textOn(color) }}>{b.job_type}</span>} />
      <Item label="Driver / team" value={b.assigned_team} testId="summary-team" />
      <Item label="Truck" value={b.truck_assigned || b.truck_size} testId="summary-truck" />
      <Item label="State" value={b.state} testId="summary-state" />
      <Item label="Pickup → Delivery" value={`${b.pickup_address} → ${b.delivery_address}`} testId="summary-route" className="col-span-2 sm:col-span-3 lg:col-span-6" />
      <Item label="Job price" value={money(b.total_estimate)} mono testId="summary-price" />
      <Item label="Deposit paid" value={`${money(b.deposit_amount)}${b.deposit_method ? ` · ${b.deposit_method}` : ""}`} mono testId="summary-deposit" />
      <Item label="Driver extras" value={money(b.driver_extras_total)} mono testId="summary-extras" />
      <Item label="Outstanding balance" value={<span className="rounded bg-[#FACC15] px-1.5 py-0.5 text-[#0E1E38]">{money(b.remaining_balance)}</span>} mono testId="summary-balance" />
      <Item label="Booked by" value={b.sales_person} testId="summary-sales" />
      <Item label="Removalists" value={b.men} mono testId="summary-men" />
    </div>
  );
};
